export class DashboardData {
	num_orders: number;
	num_products: number;
	num_companies: number;
	num_contacts: number;
	num_offers: number;
	num_open_offers: number;
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/dashboard_data.ts